import React from "react";

import ZebraDatePicker from "App/common/ui/ZebraDatePicker";
import { objectToArray, epocToDate } from "utils";
import { deepCompare } from "../../utils";

function Header(props) {
  const date = new Date(props.dates["endDate"].currentDate * 1000);
  date.setDate(date.getDate() - 89);

  const startDateMin = date.getTime() / 1000;

  return (
    <div className="cal_dd" ref={props.headerRef}>
      <div className="cal_dd_inner just_flex">
        <div className="calendar">
          <div className="calendar_inner">
            <div className="calendar_item_wrap">
              {objectToArray(props.dates).map(date => {
                let inputProps = { value: date.value };

                if (date.key === "endDate")
                  inputProps = {
                    ...inputProps,
                    direction: [
                      epocToDate(props.dates["startDate"].value, "MM-dd-yyyy"),
                      epocToDate(date.currentDate, "MM-dd-yyyy")
                    ]
                  };
                else
                  inputProps = {
                    ...inputProps,
                    direction: [
                      epocToDate(startDateMin, "MM-dd-yyyy"),
                      epocToDate(props.dates["endDate"].value, "MM-dd-yyyy")
                    ]
                  };

                return (
                  <div className="calendar_item" key={date.key}>
                    <p>{date.title}</p>

                    <ZebraDatePicker
                      idRef={date.key}
                      onChange={value =>
                        props.dateChangeHandler(date.key, value)
                      }
                      inputProps={inputProps}
                    />
                  </div>
                );
              })}
            </div>
            <div className="calendar_btn_wrap">
              <div
                className="common_btn btn_primary"
                onClick={props.formSubmitHandler}
              >
                Generate
              </div>
              <div
                className="common_btn btn_cancel"
                onClick={props.resetDatesHandler}
              >
                Reset
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Header, arePropsEqual);

function arePropsEqual(oldProps, newProps) {
  return deepCompare(oldProps, newProps);
}
